import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  FaBars,
  FaTimes,
  FaUser,
  FaHome,
  FaChalkboardTeacher,
  FaStar,
  FaBook,
  FaEdit,
} from "react-icons/fa";

import StudentSidebar from '../../components/StudentSidebar';


export default function StudentDashboard() {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-gradient-to-r from-green-400 via-blue-500 to-purple-500 text-white">
      {/* Sidebar toggle button on mobile */}
      <div className="md:hidden p-4 bg-white shadow flex justify-between items-center fixed w-full top-0 left-0 z-40">
        <button onClick={toggleSidebar} className="text-2xl text-indigo-600">
          {sidebarOpen ? <FaTimes /> : <FaBars />}
        </button>
        <h1 className="text-xl font-semibold text-indigo-600">Student Panel</h1>
        <div style={{ width: 24 }} /> {/* Placeholder for flex spacing */}
      </div>

      {/* Sidebar */}
      <StudentSidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Main Content */}
      <main
        className={`flex-1 pt-20 md:pt-6 px-6 pb-6 overflow-auto transition-all duration-300 ${
          sidebarOpen ? "blur-sm md:blur-none" : ""
        }`}
        onClick={() => sidebarOpen && toggleSidebar()} // Close sidebar on click outside
      >
        <div className="max-w-5xl mx-auto bg-white text-gray-800 rounded-xl shadow-lg p-8">
          <h1 className="text-3xl font-bold mb-6">🎓 Student Dashboard</h1>

          <div className="grid md:grid-cols-3 gap-6">
            {/* Card 1: Join Class */}
            <div className="bg-green-100 p-6 rounded-lg shadow text-center">
              <h2 className="text-xl font-semibold text-green-800">Join Class</h2>
              <p className="mt-2 text-sm">Enter your virtual class session</p>
              <button
                onClick={() => navigate("/student/join-class")}
                className="mt-4 bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded"
              >
                Join Now
              </button>
            </div>

            {/* Card 2: Rate Teacher */}
            <div className="bg-blue-100 p-6 rounded-lg shadow text-center">
              <h2 className="text-xl font-semibold text-blue-800">Rate Teacher</h2>
              <p className="mt-2 text-sm">Share feedback for your teachers</p>
              <button
                onClick={() => navigate("/student/rate-teacher")}
                className="mt-4 bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded"
              >
                Rate Now
              </button>
            </div>

            {/* Card 3: View Materials */}
            <div className="bg-purple-100 p-6 rounded-lg shadow text-center">
              <h2 className="text-xl font-semibold text-purple-800">Study Materials</h2>
              <p className="mt-2 text-sm">Download your class resources</p>
              <button
                onClick={() => navigate("/student/view-materials")}
                className="mt-4 bg-purple-600 hover:bg-purple-700 text-white py-2 px-4 rounded"
              >
                View Materials
              </button>
            </div>
          </div>

          {/* Quick Stats */}
          <div className="mt-8">
            <h3 className="text-lg font-medium">📊 Quick Stats</h3>
            <ul className="mt-2 space-y-1 text-sm text-gray-700">
              <li>🕒 Classes Attended: 12</li>
              <li>📂 Materials Downloaded: 8</li>
              <li>⭐ Teachers Rated: 3</li>
            </ul>
          </div>
        </div>
      </main>
    </div>
  );
}
